var _path, _path2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg0 = function Svg0(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7742 25H7.59417C5.72945 24.85 2 23.38 2 18.7C2 15.55 5.0625 13.3 7.25 13.3C7.25 11.95 9 7 14.25 7C17.75 7 19.5 9.25 20.5302 10.6C21.4335 10.15 23.875 10.15 25.1875 10.6C26.5 11.05 30 13.3 30 17.8C30 22.3 26.0625 25 22.7742 25Z",
    fill: "url(#paint0_linear_692_423036)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 12.5C13 12.0645 13.1693 11.4235 13.6062 10.9147C13.9997 10.4565 14.6976 10 15.999 10C17.3518 10 18.0407 10.4632 18.4155 10.9063C18.835 11.4021 18.998 12.0396 18.998 12.5C18.998 13.2582 18.4161 14.0285 17.2352 15.1104C17.1146 15.2209 16.9841 15.338 16.8488 15.4594L16.8485 15.4597C16.4283 15.8368 15.9614 16.2558 15.5993 16.6484C15.1504 17.1351 14.499 17.9461 14.499 19V20.5C14.499 21.3284 15.1706 22 15.999 22C16.8274 22 17.499 21.3284 17.499 20.5V19.0762C17.5212 19.0358 17.594 18.9106 17.8046 18.6823C18.063 18.4022 18.3704 18.1261 18.7516 17.7839L18.7516 17.7838L18.7517 17.7838C18.9087 17.6428 19.0781 17.4907 19.2618 17.3224C20.3304 16.3433 21.998 14.7418 21.998 12.5C21.998 11.4604 21.6611 10.0979 20.7059 8.96871C19.706 7.7868 18.1455 7 15.999 7C13.8836 7 12.332 7.79354 11.3301 8.96034C10.3718 10.0765 10 11.4356 10 12.5C10 13.3285 10.6716 14 11.5 14C12.3284 14 13 13.3285 13 12.5ZM15.9989 26C16.8272 26 17.4986 25.3284 17.4986 24.5C17.4986 23.6716 16.8272 23 15.9989 23C15.1707 23 14.4993 23.6716 14.4993 24.5C14.4993 25.3284 15.1707 26 15.9989 26Z",
    fill: "#90A6BC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_692_423036",
    x1: 6.91448,
    y1: 8.5068,
    x2: 24.7045,
    y2: 25.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCFE1"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg0, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/0.fdfb6849.svg";
export { ForwardRef as ReactComponent };